module.exports = __webpack_public_path__ + "static/img/award1_a.30a87d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/award1_a.png
// module id = P6l1
// module chunks = 7